import { AgDialog, AgDialogButtonConfig } from '@australiangreens/ag-internal-components';
import { useBlocker } from 'react-router';
import type { PopStateBlock } from '@hooks/useUnsavedChangesBlocker';

interface BlockerDialogProps {
  blocker: ReturnType<typeof useBlocker>;
  popStateBlock?: PopStateBlock;
}

export default function BlockerDialog({ blocker, popStateBlock }: BlockerDialogProps) {
  const isRouterBlocked = blocker.state === 'blocked';
  const isPopStateBlocked = popStateBlock?.isBlocked ?? false;
  const isOpen = isRouterBlocked || isPopStateBlocked;

  const handleDialogProceed = () => {
    if (isPopStateBlocked && popStateBlock) {
      popStateBlock.proceed();
    } else if (blocker?.proceed) {
      blocker.proceed();
    }
  };

  const handleDialogReset = () => {
    if (isPopStateBlocked && popStateBlock) {
      popStateBlock.reset();
    } else if (blocker?.reset) {
      blocker.reset();
    }
  };

  const successButtonConfig = {
    text: 'Leave',
    onClick: handleDialogProceed,
    testId: 'BlockDialog',
  } as AgDialogButtonConfig;

  const cancelButtonConfig = {
    text: 'Cancel',
    onClick: handleDialogReset,
    testId: 'BlockDialog',
  } as AgDialogButtonConfig;

  return (
    <AgDialog
      dialogTitle="Leave the page?"
      isOpen={isOpen}
      primaryButton={successButtonConfig}
      secondaryButton={cancelButtonConfig}
      onClose={handleDialogReset}
    >
      You have unsaved changes that will be lost if you leave the page. Do you wish to proceed?
    </AgDialog>
  );
}
